import "core-js/modules/es6.object.assign";
import _toConsumableArray from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { maintenance_report } from '@/api/pests'; // import print from 'print-js'
// import print from 'vue-print-nb'

export default {
  // directives: {
  //   print
  // },
  data: function data() {
    return {
      visible: false,
      carouselIndex: 0,
      imgName: [],
      statusData: {
        1: '正常',
        2: '故障',
        3: '报警'
      },
      printLoading: true,
      printObj: {
        id: "printTable",
        popTitle: '《能源管理平台》',
        extraCss: "table{border:1px solid #000}",
        extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>',
        beforeOpenCallback: function beforeOpenCallback(vue) {
          vue.printLoading = true;
          console.log('打开之前');
        },
        openCallback: function openCallback(vue) {
          vue.printLoading = false;
          console.log('执行了打印');
        },
        closeCallback: function closeCallback(vue) {
          console.log('关闭了打印工具');
        }
      },
      rishLevelData: {
        1: '低',
        2: '中',
        3: '高'
      },
      baseMessage: {
        project_name: '',
        address: '',
        maintenance_type: '',
        //维保类型
        maintenance_name: '',
        handle_time: '',
        //维保时间
        tel: '',
        customer_user: '',
        //负责人
        total_device: 0,
        contract_no: '',
        //合同编号,
        maintenance_user: '',
        //服务人员
        start_time: '',
        end_time: '',
        audit_user: ''
      },
      maintenance_area: [],
      //区域环境检查
      maintenance_medicine: [],
      //施药防控信息
      maintenance_material: [],
      //物料更换统计
      maintenance_info: [],
      //维保信息汇总
      device_detail: [],
      //防治分类
      status: null
    };
  },
  props: {
    id: {},
    shStatus: {}
  },
  watch: {
    id: function id() {
      this.init();
    }
  },
  methods: {
    showImageList: function showImageList(imgList) {
      this.imgName.splice(0);
      this.carouselIndex = 0;

      if (imgList && imgList.length === 0) {
        this.$Message.warning('暂无图片');
      } else {
        var _this$imgName;

        this.visible = true;

        (_this$imgName = this.imgName).push.apply(_this$imgName, _toConsumableArray(imgList));
      }
    },
    printPage: function printPage() {
      this.$print(this.$refs.printTable, {
        'no-print': '.className'
      });
    },
    init: function init() {
      var _this = this;

      /**
       * 获取维保报告
       */
      this.maintenance_area.splice(0);
      this.maintenance_medicine.splice(0);
      this.maintenance_material.splice(0);
      this.maintenance_info.splice(0);
      this.device_detail.splice(0);
      maintenance_report({
        id: this.id
      }).then(function (res) {
        if (res.result === 0) {
          var list = res.body;
          var maintenance_name = '';

          if (list.maintenance_type === 1) {
            maintenance_name = "定期维保";
          } else if (list.maintenance_type === 2) {
            maintenance_name = "临时维保";
          }

          Object.assign(_this.baseMessage, {
            project_name: list.project_name,
            address: list.address,
            maintenance_type: list.maintenance_type,
            handle_time: list.handle_time,
            tel: list.tel,
            customer_user: list.customer_user,
            total_device: list.total_device,
            contract_no: list.contract_no,
            maintenance_user: list.maintenance_user,
            maintenance_name: maintenance_name,
            start_time: list.start_time,
            end_time: list.end_time,
            audit_user: list.audit_user
          });
          _this.maintenance_area = list.maintenance_area || []; //环境检测信息

          _this.maintenance_medicine = list.maintenance_medicine || []; //施药防控信息

          _this.maintenance_material = list.maintenance_material || []; //物料更换统计

          _this.maintenance_info = list.maintenance_info || []; //维保信息汇总

          _this.device_detail = list.device_detail || [];
          _this.status = list.status;
        } else {}
      });
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {});
  }
};